import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { config } from '../_config/config';
import { $DBManagerService } from '../_helpers/DB/DBManager.service';
import { Constants } from '../_utils/Constants';
import { $ILogger } from '../_helpers/Logger/ILogger';
import { _contains } from '../_utils/Common';
import { logger } from '../_helpers/Logger/Logger.class';
import { IgnoreAPIList, CacheAPIList } from '../_config/restapis';

import { $BroadcastManagerService } from '../_helpers/BroadcastManager.service';


@Injectable()
export class InterceptedHttp implements HttpInterceptor {

    constructor(
        private evt: $BroadcastManagerService,
        private $db: $DBManagerService,
        private log: $ILogger,
        private router: Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        // check Cache
        // if (this.InCache(req)) return of(this.$db.get(Constants.SESSSION_STORAGE, req.url));

        // Add BaseUrl & Add Headers 
        // return next.handle(this.getBaseUrl(this.addAuthHeaders(req)))
        this.evt.emit({ click: 'SHOW' });
        return next.handle(this.getBaseUrl(req))
            .pipe(tap(res => {
                if (res instanceof HttpResponse) {
                    console.warn('Response ::', res);
                    this.evt.emit({ click: 'HIDE' });
                }
            }, err => {
                this.evt.emit({ click: 'HIDE' });
                console.warn('Error Response ::', err);
                // this.HandleErrorResponse(err);
            }));
    }

    private addAuthHeaders(req: HttpRequest<any>): HttpRequest<any> {
        // Before Login Pages No Headers
        if (_contains(req.url, IgnoreAPIList)) return req;
        return req.clone({
            setHeaders: {
                'token': this.getAuthToken,
                'Content-Type': 'application/json',
            }
        });
    }

    private HandleErrorResponse(err: any): void {
        if (err instanceof HttpErrorResponse)
            if (err.status === 401) {
                // redirect to Login Page & Clear Storage
                this.router.navigate(['/login']);
                this.$db.clearDB();
            }
    }

    private getBaseUrl(req: HttpRequest<any>): HttpRequest<any> {
        if (config.allowAll && req.url.indexOf('http') !== -1)
            return req;
        return req.clone({ url: config.baseUrl + req.url });
    }

    private getAuthToken = this.$db.get(Constants.SESSSION_STORAGE, Constants.AUTH_TOKEN);

    // check Url in CacheList & check Key in SessionStorage / Local Storage / Getters
    // check cache - true option in Http Call
    InCache(req: HttpRequest<any>): boolean {
        const url = req.url;
        return _contains(url, CacheAPIList) && this.$db.isExists(Constants.SESSSION_STORAGE, url);
    }
}

export const HttpMiddleware = {
    provide: HTTP_INTERCEPTORS,
    useClass: InterceptedHttp,
    multi: true,
};
